window.arContractDetailFormatter = function(value, row) {
    let html = '';
    html += '<table class="table table-bordered">';
    html += '<thead>';
    html += '<tr>';
    // Opdrachtgever
    html += '<td class="align-top">';
    html += '<div class="d-flex align-items-start">';
    html += '<img src="'+row.client_logo+'" class="client-logo img-fluid rounded me-2" alt="'+row.client+'">';
    html += '<div>';
    html += '<div class="fw-bold">'+__('Client')+'</div>';
    html += '<div>'+row.client+'</div>';
    html += '</div>';
    html += '</div>';
    html += '</td>';
    // ZZP-er
    html += '<td class="align-top">';
    html += '<div class="d-flex align-items-start">';
    html += '<img src="'+row.freelancer_logo+'" class="freelancer-logo img-fluid rounded me-2" alt="'+row.freelancer+'">';
    html += '<div>';
    html += '<div class="fw-bold">'+__('Freelancer')+'</div>';
    html += '<div>'+row.freelancer+'</div>';
    html += '</div>';
    html += '</div>';
    html += '</td>';
    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';
    // Opdrachtgever -> Contactpersoon
    html += '<td class="align-top">';
    html += '<div class="d-flex align-items-start">';
    html += '<img src="'+row.client_contact_avatar+'" class="client-contact-avatar img-fluid rounded me-2" alt="'+row.client_contact+'">';
    html += '<div>';
    html += '<div>'+row.client_contact+'</div>';
    html += '<i class="fal fa-envelope me-2"></i>';
    html += '<a href="mailto:'+row.client_contact_email+'" rel="nofollow">'+row.client_contact_email+'</a>';
    if (row.client_contact_phone) {
        html += '<br>';
        html += '<i class="fal fa-phone me-2"></i>';
        html += '<a href="tel:'+row.client_contact_phone+'" rel="nofollow">'+row.client_contact_phone+'</a>';
    }
    html += '</div>';
    html += '</div>';
    html += '</td>';
    // ZZP-er -> Contactpersoon
    html += '<td class="align-top">';
    html += '<div class="d-flex align-items-start">';
    html += '<img src="'+row.freelancer_contact_avatar+'" class="freelancer-contact-avatar img-fluid rounded me-2" alt="'+row.freelancer_contact+'">';
    html += '<div>';
    html += '<div>'+row.freelancer_contact+'</div>';
    html += '<i class="fal fa-envelope me-2"></i>';
    html += '<a href="mailto:'+row.freelancer_contact_email+'" rel="nofollow">'+row.freelancer_contact_email+'</a>';
    if (row.freelancer_contact_phone) {
        html += '<br>';
        html += '<i class="fal fa-phone me-2"></i>';
        html += '<a href="tel:'+row.freelancer_contact_phone+'" rel="nofollow">'+row.freelancer_contact_phone+'</a>';
    }
    html += '</div>';
    html += '</div>';
    html += '</td>';
    html += '</tbody>';
    html += '</table>';
    return html;
};
